RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const TokenCoverage = RivalIQ.data.CacheLayer.extend({
        name: 'DiscoveryTokenCoverage',
        cacheKeys: [],

        loadData: function () {
            const url = `/api/accounts/${RivalIQ.state.account.get('id')}/discovery/tokenCoverage`;
            return $.get(url);
        }
    });

    data.tokenCoverage = new TokenCoverage();
});
